"use client";

import { useSyncExternalStore } from "react";
import { Button } from "@/components/ui/design-system/button";
import type { SessionRecovery } from "./sessionRecovery";

export function SessionRecoveryBanner({
  recovery,
}: {
  recovery: SessionRecovery;
}) {
  const ended = useSyncExternalStore(
    recovery.subscribe,
    recovery.getSnapshot,
    () => false,
  );

  if (!ended) return null;

  function signIn() {
    // Back to this page once signed in again (/sign-in/continue).
    window.location.assign(
      `/sign-in?${new URLSearchParams({
        redirect: `${window.location.pathname}${window.location.search}${window.location.hash}`,
      })}`,
    );
  }

  return (
    <section
      aria-label="Sign-in required"
      role="alert"
      className="fixed bottom-4 left-4 right-4 z-[100] mx-auto flex max-w-3xl flex-wrap items-center gap-nf-ds-4 rounded-nf-ds-lg border border-nf-ds-warning bg-nf-ds-tone-warn-bg p-nf-ds-4 font-nf-ds-sans text-nf-ds-tone-warn-fg shadow-nf-ds-lg"
    >
      <div className="min-w-0 flex-1">
        <p className="font-[600]">Your session has ended</p>
        <p className="text-sm">
          Sign in again to load and save your work. Copy any unsaved work before
          continuing.
        </p>
      </div>
      <Button variant="ink" onClick={signIn}>
        Sign in again
      </Button>
    </section>
  );
}
